module.exports = __webpack_public_path__ + "julia-4a7ef95e74e37d6e9542235792a761f3.webp";